<template>
	<div>
		<Header></Header>
		<searchShop></searchShop>
		<Nav></Nav>
		<div class="content">
			<div class="w">
				<!-- 商品属性 -->
				<div class="goods d-flex justify-content-between">
					<!-- 左边图片 -->
					<div class="goods-l">
						<div class="img">
							<pic-zoom :url="goods.image_path" :scale="1.5"></pic-zoom>
						</div>
						<div class="img-list d-flex justify-content-between align-items-center">
							<div class="swiper-container goods-img swiper-no-swiping">
								<div class="swiper-wrapper">
									<div class="swiper-slide img-item">
										<img class="img-default" :src="goods.image_path">
									</div>
								</div>
							</div>
						</div>
					</div>
					<!-- 中间 -->
					<div class="goods-c">
						<div class="name">{{goods.name}}</div>
						<ul>
							<li>政府采购品目名称：{{goods.cat_name}}</li>
							<li>政府采购品目编码：{{goods.category}}</li>
							<li>本网价：￥{{goods.price}}</li>
							<li>SKU：{{goods.sku}}</li>
							<li>型号：{{goods.typeno}}</li>
							<li>品牌：{{goods.brand_name}}</li>
							<li>库存：{{goods.goods_num}}</li>
							<li>预计到达：{{goods.deliveryDay}} 天</li>
						</ul>
					</div>
				</div>
				<!-- 商品详情 -->
				<div class="details d-flex justify-content-between">
					<div class="details-r">
						<div class="details-r-box">
							<div class="tab d-flex">
								<div class="tab-item" @click="detailsClick(0)" :class="{details_active: 0 ==detailsIndex}">商品详情</div>
								<div class="tab-item" @click="detailsClick(1)" :class="{details_active: 1 ==detailsIndex}">商品参数</div>
								<div class="tab-item" @click="detailsClick(2)" :class="{details_active: 2 ==detailsIndex}">售后服务</div>
								<div class="tab-item" @click="detailsClick(3)" :class="{details_active: 3 ==detailsIndex}">包装清单</div>
							</div>
							<!-- 详情 -->
							<div class="conter" v-if="detailsIndex == 0">
								<div class="conter-img" v-html="goods.introduction"></div>
							</div>
							<!-- 商品参数 -->
							<div class="conter" v-if="detailsIndex == 1">
								<div class="conter-img" v-html="goods.param"></div>
							</div>
							<!-- 售后服务 -->
							<div class="conter" v-if="detailsIndex == 2">
								<div class="conter-img" v-html="goods.service"></div>
							</div>
							<!-- 包装清单 -->
							<div class="conter" v-if="detailsIndex == 3">
								<div class="conter-img" v-html="goods.ware"></div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
		<Foot></Foot>
	</div>
</template>

<script>
	import Header from "@/components/header/header";
	import Foot from "@/components/foot/foot";
	import searchShop from "@/components/search/searchShop";
	import Nav from "@/components/nav/nav";
	import {
		Swiper,
		SwiperSlide
	} from "vue-awesome-swiper";
	import "./details.css";
	import PicZoom from 'vue-piczoom'
	export default {
		components: {
			Header,
			Foot,
			searchShop,
			Nav,
			PicZoom
		},
		data() {
			return {
				goods_id: this.$route.query.goods_id, //商品id
				detailsIndex: 0,
				goods: {
					image_path: ''
				}
			};
		},
		created() {
			this.getData();
		},
		watch: {
			$route(to, from) {
				//监听路由是否变化
				if (to.query.goods_id != from.query.goods_id) {
					this.goods_id = to.query.goods_id;
					this.getData();
					this.detailsIndex = 0;
				}
			},
		},
		methods: {
			getData(){
				this.$loading(this.goods_id);
				let params = {
					goods_id: this.goods_id,
				};
				this.$api.hbDetails(params).then((res)=>{
					this.$loading().close();
					console.log(res)
				}).catch((error)=>{
					this.$loading().close();
					this.goods = error.result;
				})
			},
			// 分类
			detailsClick(e) {
				this.detailsIndex = e;
			}
		}
	};
</script>

<style lang="scss">
	.details_active {
		border-top: 2px solid #ff0e25;
		background-color: #fff;
		color: #ff0e25;
	}
	
	.content {
		margin-top: 24px;
	}

	// 商品属性
	.goods {

		.goods-l {
			width: 408px;
			.img {
				position: relative;
				height: 408px;
				width: 408px;
				border: 1px solid #efefef;
			}

			.img-list {
				width: 408px;
				margin-top: 12px;
				height: 60px;
				padding: 0;
				box-sizing: border-box;
				position: relative;

				.goods-img {
					width: 408px;
					height: 60px;

					.img-item {
						height: 60px;
						width: 60px !important;
						border: 2px solid transparent;
						box-sizing: border-box;
						margin-right: 8px;
						cursor: pointer;

						img {
							width: 56px;
							height: 56px;
							object-fit: cover;
							display: block;
						}

						&:hover {
							border-color: #ff0e25;
						}
					}
				}
			}
		}

		.goods-c {
			width: 749px;
			padding-bottom: 57px;
			box-sizing: border-box;

			.name {
				font-size: 16px;
				font-weight: 600;
			}
			ul{
				margin-top: 10px;
				li{
					font-size: 14px;
					color: #666666;
					line-height: 30px;
				}
			}
		}
	}
	// 商品详情
	.details {
		margin-top: 21px;

		.details-r {
			width: 100%;

			.details-r-box {
				width: 100%;
				// padding-bottom: 50px;
				border: 1px solid #ebebeb;
				box-sizing: border-box;

				.tab {
					height: 46px;
					background-color: #fafafa;

					.tab-item {
						height: 46px;
						padding: 0 24px;
						line-height: 46px;
						box-sizing: border-box;
						cursor: pointer;
					}

					.tab-active {
						background-color: #fff;
						border-top: 2px solid #ff0e25;
					}
				}

				// 详情
				.conter {
					padding: 0 24px;
					box-sizing: border-box;
					.conter-img {
						margin-top: 40px;
						margin-bottom: 50px;
					}
				}
			}

			.details-r-box:last-child {
				margin-bottom: 42px;
			}
		}
	}
	.mouse-cover-canvas{
		top: 207px !important;
		left: 50% !important;
		margin-left: -176px;
	}
</style>
